export type MessageContent = string | JSX.Element;
export enum PostTypes {
    SEARCH,
    CONFESSION
};